import { Component, Input } from '@angular/core';
import { InstallSpecDialogComponent } from '../../solution-onboarding/install-spec-dialog/install-spec-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
@Component({
    selector: 'app-sidenav-capability',
    templateUrl: './sidenav-capability.component.html',
    styleUrls: ['./sidenav-capability.component.scss'],
    standalone: false
})
export class SidenavCapabilityComponent {

  @Input() name: string;
  @Input() version: string;
  @Input() releaseVersion: string;
  @Input() componentType: string;
  @Input() displayName: string;
  @Input() description: string;
  @Input() parameterSpec: any;
  @Input() dateCreated: string;
  @Input() dateUpdated: string;
  @Input() category: string;
  
  constructor(private dialog: MatDialog)   {
 }
 
  onClick(installSpec): void {
      this.dialog.open(InstallSpecDialogComponent, {
        minHeight: '342px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title:  translate('SOLUTIONS.INSTALLATION_SPECIFICATION'),
          description: installSpec
        }
      });
    }
}
